import {PrizeType} from 'utils/DBUtils';
import Columns from './columns';

export default {
  editorial: {
    columns: [
      Columns.Title,
      Columns.PublishStatus,
      Columns.Points,
      Columns.Entries,
      Columns.StartDate,
      Columns.EndDate,
      Columns.Winner,
      Columns.Actions
    ],

    prizeType: PrizeType.RAFFLE,

    documentTitle: 'Editorial Sweeps',
    topLevelClassName: 'editorial-sweeps',
    spinnerMessage: 'loading.prizes.editorial',
    dateFormat: 'MM/DD/YY'
  },

  sponsored: {
    columns: [
      Columns.Title,
      Columns.PublishStatus,
      Columns.BreakId,
      Columns.Entries,
      Columns.StartDate,
      Columns.EndDate,
      Columns.Winner,
      Columns.Actions
    ],

    prizeType: PrizeType.CHALLENGE,

    documentTitle: 'Sponsored Prizing',
    topLevelClassName: 'sponsored-prizing',
    spinnerMessage: 'loading.prizes.sponsored',
    dateFormat: 'MM/DD/YY'
  }
};



// WEBPACK FOOTER //
// ./public/pages/ListPrizes/configs.js